import { css, SerializedStyles } from '@emotion/core';

import { ICustomTheme } from 'interfaces';
import { getMainColor } from '../../pages/DetailsPage/common/styles';

export const cssCard = css({
  padding: 0,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const getCssHeader =
  (isDisabled?: boolean) =>
  (theme: ICustomTheme): SerializedStyles =>
    css({
      backgroundColor: getMainColor(theme, isDisabled),
      height: 50,
    });

export const getCssRange =
  (isDisabled?: boolean) =>
  (theme: ICustomTheme): SerializedStyles =>
    css({
      color: getMainColor(theme, isDisabled),
    });

export const cssHeaderTitle = (theme: ICustomTheme): SerializedStyles =>
  css({
    fontWeight: theme.typography.fontWeightBold,
    padding: theme.spacing(2, 2, 2, 0),
    color: theme.colors.white,
  });

export const cssProductDetails = (theme: ICustomTheme): SerializedStyles =>
  css({
    padding: theme.spacing(1),
    flex: 1,
  });

export const cssBold = (theme: ICustomTheme): SerializedStyles =>
  css({
    fontWeight: theme.typography.fontWeightBold,
  });

export const cssProductDescription = (theme: ICustomTheme): SerializedStyles =>
  css({
    color: theme.colors.grey.light2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': '3',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
  });
